import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import groupImage from '../OrgImages/orgpgroupimage.webp';
import quotes from '../OrgImages/quotes.svg';
import repAvatar from '../OrgImages/repavatar.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const OrgSubmissionShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'contain');

  return (
    <section
      ref={sectionRef}
      className='relative h-full w-full overflow-hidden bg-warning-25'
    >
      <div className='flex h-full w-full items-center justify-center'>
        <div style={wrapperStyle}>
          <div style={canvasStyle}>
            <img
              src={groupImage}
              alt=''
              className='absolute rounded-2xl object-cover'
              style={{ top: 40, left: 40, width: 560, height: 280 }}
            />

            <img
              src={quotes}
              alt=''
              className='absolute'
              style={{ top: 300, left: 40, width: 100, height: 100 }}
            />

            <p
              className='absolute m-0 text-center text-xl font-medium text-gray-700'
              style={{ top: 360, left: 20, width: 590 }}
            >
              Thank you very much, this wouldn't have been possible <br/> without the
              support we have received from <br/> Movingworlds.
            </p>

            <img
              src={repAvatar}
              alt=''
              className='absolute rounded-full'
              style={{ top: 500, left: 288, width: 64, height: 64 }}
            />

            <p
              className='absolute m-0 text-center text-base font-semibold text-gray-700'
              style={{ top: 576, left: 60, width: 520 }}
            >
              Muyunda Kaonga
            </p>

            <p
              className='absolute m-0 text-center text-sm font-medium text-avatar-text'
              style={{ top: 602, left: 60, width: 520 }}
            >
              Founder and CEO @Ebusaka
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
